import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f016787c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Логин", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "ФИО", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Компания", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Роли пользователя", -1))
const _hoisted_5 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DefinePasswordControl = _resolveComponent("DefinePasswordControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    onOnShown: _ctx.onShown,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Логин...",
          "show-clear-button": true,
          value: model.userName,
          "onUpdate:value": ($event: any) => ((model.userName) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "ФИО...",
          "show-clear-button": true,
          value: model.fullName,
          "onUpdate:value": ($event: any) => ((model.fullName) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_CatalogueSelectControl, {
          class: "ModelField-selectControl",
          stylingMode: "outlined",
          id: model.companyId,
          "onUpdate:id": ($event: any) => ((model.companyId) = $event),
          desc: model.companyDescription,
          "onUpdate:desc": ($event: any) => ((model.companyDescription) = $event),
          displayDescField: "name",
          keyField: "id",
          catalogueComponentName: "catalogues/CompanyCatalogue/CompanyCatalogue",
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
      ]),
      _createVNode(_component_DefinePasswordControl, {
        value: model.password,
        "onUpdate:value": ($event: any) => ((model.password) = $event)
      }, null, 8, ["value", "onUpdate:value"]),
      _hoisted_4,
      _createElementVNode("div", {
        class: "UserCreateEditDialog_roleSubGrid",
        id: _ctx.roleSubGridDomId
      }, null, 8, _hoisted_5)
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}